import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { DcBaseRequester } from './dc-base.requester';
import { IBasicUser } from './models/basic-user.model';
import { IProjectMemberModel } from './models/project-member.model';

@Injectable({
	providedIn: 'root',
})
export class ProjectMemberRequester extends DcBaseRequester<IProjectMemberModel> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;
	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = this.generateResourceUrl('USERS_BASIC');
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getAvailableMembersFromAllProjects(): Observable<
		ReadonlyArray<IProjectMemberModel>
	> {
		const url = this.urlService.generateUrl(this.resource, {}, {});
		return this.get<Array<IProjectMemberModel>>(
			url,
			CachePolicyEntity.build({
				isCacheable: true,
				maxAgeInSeconds: 1 * 60,
				policy: CachePolicy.CacheOnly,
			})
		);
	}

	public getUserDetailsById(userId: string): Observable<IBasicUser> {
		const resourceUrl = this.generateResourceUrl('USER_BASIC');
		const url = this.urlService.generateUrl(
			resourceUrl,
			{
				userId,
			},
			{
				isGroup: false,
			}
		);
		return this.get<IBasicUser>(
			url,
			CachePolicyEntity.build({
				isCacheable: true,
				maxAgeInSeconds: 1 * 60,
				policy: CachePolicy.CacheOnly,
			})
		);
	}
}
